export default __webpack_public_path__ + "static/media/check_circle_green.6e259c6f.svg";